import { reactive } from "vue"
import router from '@/router'

import { tagService } from '@/http'


const store = reactive({
  isAuth: false,
  user: null,
  dbg: null,
  tags: [],
  isDatingView: localStorage.getItem('dating_view') || false,
  cards: {
    page: 1
  },
  changeView(value) {
    store.isDatingView = value
    if(value) {
      localStorage.setItem('dating_view', value)
    } else {
      localStorage.removeItem('dating_view')
    }
  },
  setAuth(token) {
    localStorage.setItem('token', token)
    store.isAuth = true
  },
  login(data) {
    localStorage.setItem('token', data.token)
    store.user = data.data
    store.isAuth =  true
  },
  logout() {
    
    //const router = useRouter()
    // console.log(router)
    // router.push({
    //   name: 'index'
    // })
    localStorage.removeItem('token')
    location.href = '/'
  },
  loadTags() {
    tagService.index().then(res => {
      store.tags = res.data.items
    })
  }
});


export default store;